// green light

export const GREEN_LIGHT = "#d4edda";

export const GREEN =  "#28a745";

export const GREEN_BG =  "#d4edda";

export const GREEN_BORDER =  "#c3e6cb";

export const RED_LIGHT = "#f8d7da";

export const BLUE_STRONG = "#004085";

export const GREY_LIGHT = "#D5E5F2";

export const BLUE = "#007bff";

export const BLUE_BG ="#cce5ff";

export const BLUE_BORDER ="#b8daff";

export const SECONDARY = "#e2e3e5";

export const WARNING = "#fff3cd";

export const INFO = "#17a2b8";

export const LIGHT_BG = "#f8f8f8";

export const LIGHT_BORDER = "#fdfdfe";


//background-color: #d4edda;